<core-pdfjs-viewer
    *ngIf="status != ERROR else loadnoteserror"
    [file]="file"
    [viewerUser]="user"
    [notesLegacy]="notes"
    [annotations]="annotations"
    [annotationsAllowed]="canCreateNotes"
    (onSaveAnnotations)="saveAnnotations($event)"
></core-pdfjs-viewer>

<ng-template #loadnoteserror>
    <div *ngIf="status == ERROR" class="notes-load-error">
        <core-helpers-box-alert-message-icon [text]="'There was an error loading notes.'"
            [icon]="'alert'"></core-helpers-box-alert-message-icon>
    </div>
</ng-template>

